<template>
  <Bar id="my-chart-id" :options="options" :data="chartData" />
</template>

<script>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import AnnotationPlugin from "chartjs-plugin-annotation";

// Register Chart.js components and plugin
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  AnnotationPlugin
);

export default {
  components: {
    Bar,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    annotations: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      required: true,
    },
    aspectRatio: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup(props) {
    // Calculate the average score
    const calculateAverage = (data) => {
      if (!data || data.datasets.length === 0) return 0;
      const values = data.datasets[0].data;
      const total = values.reduce((sum, value) => sum + value, 0);
      return total / values.length;
    };

    // const averageScore = calculateAverage(props.chartData.datasets[1].data);
    const dataset =
      props.chartData.datasets[props.chartData.datasets.length - 1].data;
    const sum = dataset.reduce((total, value) => total + value, 0);
    const averageScore = sum / dataset.length;

    const annotationColors = ["#ff0000", "#ff8000", "#e45700"]
    const chartAnnotations = props.annotations.reduce((acc, item, index) => {
      acc[`line${index}`] = {
        type: "line",
        xMin: item.value, // Set to average score
        xMax: item.value, // Set to average score
        borderColor: annotationColors[index] || "#e49300",
        borderWidth: 2,
        label: {
          content: item.label,
          enabled: true,
          position: "top",
        },
      }

      return acc
    }, {})

    return {
      chartData: props.chartData,
      options: {
        ...props.options,
        plugins: {
          ...props.options.plugins,
          annotation: {
            annotations: chartAnnotations
          },
        },
      },
    };
  },
};
</script>

<style scoped></style>
